// src/ui/components/common/WhatsAppIcon.tsx
import React from 'react';

interface Props { size?: number; color?: string; }

export const WhatsAppIcon: React.FC<Props> = ({ size = 26, color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path
      d="M16 3C9.373 3 4 8.373 4 15c0 2.385.668 4.61 1.832 6.5L4 29l7.7-1.807A12.94 12.94 0 0016 28c6.627 0 12-5.373 12-12S22.627 3 16 3z"
      fill={color}
    />
    <path
      d="M12.5 11c-.3-.7-.6-.7-.9-.7-.23 0-.5 0-.76.003-.26.003-.68.1-1.04.5-.36.4-1.37 1.34-1.37 3.26 0 1.92 1.4 3.78 1.6 4.04.2.26 2.72 4.34 6.7 5.9 3.32 1.3 3.98 1.04 4.7.97.72-.07 2.3-.94 2.63-1.85.33-.91.33-1.69.23-1.85-.1-.16-.36-.26-.76-.46s-2.3-1.14-2.66-1.27c-.36-.13-.62-.2-.88.2-.26.4-.98 1.27-1.2 1.53-.22.26-.44.3-.84.1-.4-.2-1.68-.62-3.2-1.97-1.18-1.05-1.98-2.35-2.21-2.75-.23-.4-.02-.61.17-.81.18-.18.4-.47.6-.7.2-.23.26-.4.4-.66.13-.27.07-.5-.03-.7z"
      fill="#25D366"
    />
  </svg>
);
